var exports = {
  "As": "diffEntry__FFQgYX",
  "bm": "diffHeader__V7ZjDY",
  "t5": "diffContent__ofoMsV",
  "yM": "diffContentCollapsed__TtJ5kY",
  "S": "loadingSpinner__CmthvG",
  "YI": "diffOverlay__6Lf_8E",
  "mg": "placeholderSvg__meBunM",
  "BG": "placeholderPath__JBea3-",
};

module.exports = exports;
